import React from 'react'
import Link from 'gatsby-link'

const IndexPage = () => (
  <div className="container-fluid">
    <div className="row" style={{paddingTop: '2em'}}>
      <div className="col-sm">
        <div style={{textAlign: 'center'}}>
          <h1>Thinking about selling?</h1>
          <p></p>
          <ul>
            <li>Avoid negative news. Do not check prices (daily). Do not indulge in short term negative press coverage.</li>
            <li>Get involved beyond just owning crypto. Spread adoption. Learn how to code. Quit your job and join crypto related company.</li>
            <li>This transformation will not happen by sitting around and watching prices go up and down.</li>
            <li>To get you back on track, check out what the big boys are saying:</li>
          </ul>
          <iframe id="video" width="560" height="315" src="https://www.youtube.com/embed/lp5Yx34SO58" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          <div id="disclaimer">
            This page aims at giving emotional support to crypto investors. Obviously heavily under construction at this point. Get in touch:
            <Link to="https://bergwiese.co">Bergwiese UG (haftungsbeschränkt)</Link>.
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js